module.exports = __webpack_public_path__ + "static/media/ssc-tb.94c2ddad.woff";